import { AuthStateModel } from '@store/auth/auth.typings';
import { SignInResponse, UserPersonalData } from '../../types/auth';

export class SignIn {
  static readonly type = '[Auth] Sign In';
  constructor(public auth: SignInResponse) {}
}

export class SetUserPersonalData {
  static readonly type = '[Auth] Set User Personal Data';
  constructor(public userPersonalData: UserPersonalData) {}
}

export class SyncState {
  static readonly type = '[Auth] Sync State';
  constructor(public state: AuthStateModel) {}
}
export class RefreshAuth {
  static readonly type = '[Auth] Refresh Auth';
  constructor(public auth: SignInResponse) {}
}
export class Logout {
  static readonly type = '[Auth] Logout';
}

export class SetUserDivisions {
  static readonly type = '[Auth] Set user divisions';
}

export class SetUserActiveDivision {
  static readonly type = '[Auth] Set user active division';
  constructor(public id: number) {}
}
